// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1RF7T";
export var title = "hero-module--title--1uaDR";